import { LogOut } from "lucide-react";
import { useTransition } from "react";

import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type SignOutButtonProps = {
  iconOnly?: boolean;
  className?: string;
};

export function SignOutButton({ iconOnly = false, className }: SignOutButtonProps) {
  const { signOut } = useAuth();
  const [isPending, startTransition] = useTransition();

  const onClick = () =>
    startTransition(() => {
      void signOut({ callbackUrl: "/admin/signin" });
    });

  if (iconOnly) {
    return (
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        className={cn("shrink-0", className)}
        title={isPending ? "Signing out…" : "Sign out"}
        disabled={isPending}
        onClick={onClick}
      >
        <LogOut className="size-4" />
        <span className="sr-only">{isPending ? "Signing out" : "Sign out"}</span>
      </Button>
    );
  }

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className={cn(className)}
      disabled={isPending}
      onClick={onClick}
    >
      <LogOut className="size-3.5" />
      {isPending ? "Signing out…" : "Sign out"}
    </Button>
  );
}
